var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "modal-decline-reason",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "modal-decline-reason",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _vm.monetaryCurrency
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-block",
                    class: _vm.reason === "budget" ? "btn-primary" : "btn-dark",
                    attrs: {
                      type: "button",
                      "data-dismiss": _vm.talentCanComment ? null : "modal",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleDeclineRequestReasonCallback("budget")
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("sentenceCase")(_vm.$t("budget"))) +
                        " too low\n        "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-block",
                class: _vm.reason === "scheduling" ? "btn-primary" : "btn-dark",
                attrs: {
                  type: "button",
                  "data-dismiss": _vm.talentCanComment ? null : "modal",
                },
                on: {
                  click: function ($event) {
                    return _vm.handleDeclineRequestReasonCallback("scheduling")
                  },
                },
              },
              [_vm._v("\n          Scheduling issue\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-block",
                class:
                  _vm.reason === "information" ? "btn-primary" : "btn-dark",
                attrs: {
                  type: "button",
                  "data-dismiss": _vm.talentCanComment ? null : "modal",
                },
                on: {
                  click: function ($event) {
                    return _vm.handleDeclineRequestReasonCallback("information")
                  },
                },
              },
              [_vm._v("\n          Need more information\n        ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-block",
                class: _vm.reason === "interest" ? "btn-primary" : "btn-dark",
                attrs: {
                  type: "button",
                  "data-dismiss": _vm.talentCanComment ? null : "modal",
                },
                on: {
                  click: function ($event) {
                    return _vm.handleDeclineRequestReasonCallback("interest")
                  },
                },
              },
              [_vm._v("\n          Not interested\n        ")]
            ),
            _vm._v(" "),
            _vm.talentCanComment
              ? _c("div", [
                  _c("div", { staticClass: "decorative-divider" }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "scheduling_comment" } }, [
                    _vm._v("Provide a comment (optional)"),
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.decline_comment,
                        expression: "decline_comment",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { id: "scheduling_comment", rows: "2" },
                    domProps: { value: _vm.decline_comment },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.decline_comment = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  !_vm.$vlastMode && _vm.talentIsShortlisted
                    ? _c("span", [
                        _vm._v(
                          "Please note that the client will see your comment"
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-dark margin-y-1",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.handleDeclineWithCommentCallback },
                    },
                    [_vm._v("\n            Submit\n          ")]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }